export function validateRange(config) {
    const qty = Number(config.expectedQuantity);
    if (!Number.isFinite(qty) || qty <= 0) {
        return "Expected quantity must be > 0.";
    }

    const minPrice = Number(config.minPrice);
    const maxPrice = Number(config.maxPrice);
    const delayMinutes = Number(config.delayMinutes);

    if (!Number.isFinite(minPrice) || minPrice <= 0) {
        return "Lowest price must be > 0.";
    }
    if (!Number.isFinite(maxPrice) || maxPrice <= 0) {
        return "Highest price must be > 0.";
    }
    if (maxPrice < minPrice) {
        return "Highest price must be ≥ lowest price.";
    }
    if (!Number.isFinite(delayMinutes) || delayMinutes <= 0) {
           return "Delay (minutes) must be > 0 for RANGE orders.";
    }

    const lot = Number(config.lotSize);
    if (Number.isFinite(lot) && lot > 0) {
        if (qty < lot) return `Expected quantity must be at least 1 lot (${lot}).`;
        if (qty % lot !== 0) return `Expected quantity must be a multiple of lot size (${lot}).`;
    }

    return null;
}
